<template>
  <notice-box v-if="errors && Object.keys(errors).length" class="-error _mb-sm-20 _mb-md-60" role="alert">
    <template v-if="columnOnly">
      <notice-header>
        <h3 class="heading">以下の項目をご確認ください。</h3>
      </notice-header>
      <notice-body v-if="items">
        <ul v-for="key in items" :key="key">
          <li v-if="errors.hasOwnProperty(key)">{{ $t('label.'+ key) }}</li>
        </ul>
      </notice-body>
      <notice-body v-else>
        <ul v-for="key in Object.keys(errors)" :key="key">
          <li>{{ $t('label.'+ key) }}</li>
        </ul>
      </notice-body>
    </template>
    <template v-else-if="title">
      <notice-header>
        <h3 class="heading">{{title}}</h3>
      </notice-header>
    </template>
    <template v-else-if="errorOnly">
      <notice-header v-for="key in Object.keys(errors)" :key="key">
        <h3 class="heading" v-for="(val, index) in errors[key]" :key="index">
          {{ $t('errors.input.message.'+ val.replace(/\s+/g, '')) }}
        </h3>
      </notice-header>
    </template>
    <template v-else>
      <notice-header>
        <h3 class="heading">以下の内容をご確認ください。</h3>
      </notice-header>
      <notice-body v-if="items">
        <ul v-for="key in items" :key="key">
          <template v-if="errors.hasOwnProperty(key)">
            <li v-for="(val, index) in errors[key]" :key="index" v-html="$t('errors.message.'+ val.replace(/\s+/g, ''), { key: $t('label.'+ key) })"></li>
          </template>
        </ul>
      </notice-body>
      <notice-body v-else>
        <ul v-for="key in Object.keys(errors)" :key="key">
          <li v-for="(val, index) in errors[key]" :key="index" v-html="$t('errors.message.'+ val.replace(/\s+/g, ''), { key: $t('label.'+ key) })"></li>
        </ul>
      </notice-body>
    </template>
  </notice-box>
</template>

<script>
import NoticeBox from '../box/NoticeBox'
import NoticeHeader from '../box/NoticeHeader'
import NoticeBody from '../box/NoticeBody'

export default {
  name: 'errors-alert',
  components: {NoticeBody, NoticeHeader, NoticeBox},
  props: {
    errors: {},
    columnOnly: false,
    errorOnly: false,
    title: '',
    items: null
  }
}
</script>

<style lang="scss" scoped>
</style>



// WEBPACK FOOTER //
// src/components/alert/ErrorsAlert.vue